import * as Sentry from "@sentry/capacitor";

import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";
import { AgentStage } from "@/Modules/Agent/Models/Domain";

import { getConversation } from "@/Services/TherapyApi/Agent";
import AnswerTransformer from "@/Modules/Transformers/Agent/Answer";

import useAgentStore from "@/Modules/Agent/Store";
import useAppStore from "@/Modules/App/Store";

import { hasValue } from "@/Utils/Objects";
import { danger } from "@/Utils/Debug";

async function fetchConversationAH(customerUuid: string) {
  const agentStore = useAgentStore();
  const appStore = useAppStore();

  if (!hasValue(customerUuid)) return undefined;

  agentStore.agentStage = AgentStage.LOADING;

  try {
    const response = await getConversation(customerUuid);
    const conversationApi = response.body;
    const conversationDomain = conversationApi.map(AnswerTransformer.toDomain);

    agentStore.conversation = conversationDomain;
    agentStore.setRatingModalVisible(response.meta.maia_rating);
  } catch (error: unknown) {
    danger(error);
    Sentry.captureException(error);
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });
  } finally {
    agentStore.agentStage = null;
  }
}

export default fetchConversationAH;
